import API from './api'

export default {
	upgrade(planId, addMultiYard) {
		const api = new API(1, 'account/upgrade')

		return api.post({ planId, addMultiYard })
	},

	cancel() {
		const api = new API(1, 'account/cancel')

		return api.delete('')
	}
}


// WEBPACK FOOTER //
// ./src/lib/subscription.js